<template>

    <div class="page">
        <SidebarBody/>
        <BorrowBody/>
    </div>
    
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import SidebarBody from "@/components/dashboard/SidebarBody.vue";
  import BorrowBody from "@/components/dashboard/BorrowBody.vue";
  
  export default defineComponent({
    name: "BorrowView",
    components: {
      SidebarBody,
      BorrowBody
    },
  });
  </script>
  